import _ from "lodash";

export const condObj = (
  condition: boolean,
  trueObject: any,
  falseObject = {}
) => (condition ? trueObject : falseObject);

export const prependZeroes = (num: number, maxDigits: number) => {
  let numStr = num + "";

  while (numStr.length < maxDigits) numStr = "0" + numStr;

  return numStr;
};

type ObjectKeyPathNonEmpty<O extends object> =
  | [keyof O]
  | [keyof O, ...ObjectKeyPath<O[keyof O]>];
export type ObjectKeyPath<O> = O extends object
  ? [] | ObjectKeyPathNonEmpty<O>
  : never;

export type ObjectKeyPathValueType<O, OKP extends ObjectKeyPath<O>> = any;

export const setObjectValue = <T extends object, OKP extends ObjectKeyPath<T>>(
  obj: T,
  pathArr: OKP,
  value: any
) => {
  return _.set(obj, pathArr.join("."), value);
};
